import React from 'react';
import { Dropdown } from '../Dropdown';

function Filter({ column }) {
  const { filters, header, filterMultiple } = column.columnDef;
  const renderDropDownValue = () => {
    let filterValueLength = 0;
    if (filterMultiple) {
      filterValueLength = column.getFilterValue()?.length;
    }
    const showLengthText = filterValueLength > 0 ? `(${filterValueLength})` : '';
    return column.getFilterValue() ? `${header} ${showLengthText}` : header;
  };

  return (
    <div className="table_filter_dropdown">
      <Dropdown
        multiple={filterMultiple}
        onSelect={(value) => {
          column.setFilterValue(value);
        }}
        customSelectValue={renderDropDownValue()}
        clearAll
        value={column.getFilterValue() || []}
      >
        {filters?.map((filter) => {
          return (
            <option key={filter.value} value={filter.value}>
              {filter.label}
            </option>
          );
        })}
      </Dropdown>
    </div>
  );
}

export default Filter;
